<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Contents">
<p class="toc_h"><span class="right_1" epub:type="pagebreak" id="page_ix" title="ix"><b>CONTENTS</b></span></p>
<p class="toc_fm" id="rsec1"><a href="#/text/9780253064967_Acknowledgments#sec1">Acknowledgments</a></p>
<p class="toc_fmt" id="rsec2"><a href="#/text/9780253064967_Introduction#sec2">Introduction</a></p>
<p class="toc_cn" id="rsec3"><a href="#/text/9780253064967_Chapter01#sec3">1.<span class="sptoc">Rooted: A Contingent Look at Polish Jews in the Late 1930s</span></a></p>
<p class="toc_cn" id="rsec4"><span href="#/text/9780253064967_Chapter02#sec4" title="Link target outside of Sample">2.<span class="sptoc">In Exile: Debating Postwar Plans during an Uprooted Present, 1940–1943</span></span></p>
<p class="toc_cn" id="rsec5"><span href="#/text/9780253064967_Chapter03#sec5" title="Link target outside of Sample">3.<span class="sptoc">Negating This Diaspora: The World Jewish Congress and the Prioritization of Postwar Life in Palestine, 1942–1944</span></span></p>
<p class="toc_cn" id="rsec6"><span href="#/text/9780253064967_Chapter04#sec6" title="Link target outside of Sample">4.<span class="sptoc">Uncertain Citizenship: Anxious Postwar Returns to East Central Europe, 1945–1946</span></span></p>
<p class="toc_cn" id="rsec7"><span href="#/text/9780253064967_Chapter05#sec7" title="Link target outside of Sample">5.<span class="sptoc">Uprooted: The “Miraculous” Remnant of Polish Jews Who Survived in the Soviet Union and Their Postwar Migrations</span></span></p>
<p class="toc_fmb" id="rsec8"><span href="#/text/9780253064967_Conclusion#sec8" title="Link target outside of Sample">Conclusion: Postwar Life Is Elsewhere</span></p>
<p class="toc_fm" id="rsec9"><span href="#/text/9780253064967_Notes#sec9" title="Link target outside of Sample">Notes</span></p>
<p class="toc_fm" id="rsec10"><span href="#/text/9780253064967_Bibliography#sec10" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc_fm" id="rsec11"><span href="#/text/9780253064967_Index#sec11" title="Link target outside of Sample">Index<span class="right_1" epub:type="pagebreak" id="page_x" title="x"></span></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253064967_Contents.vue?125337fd